import * as ng from 'angular';

export class UISelectService {

    clear($event: Event, $select: any) {
        // stops click event bubbling
        $event.stopPropagation();
        // to allow empty field, in order to force a selection remove the following line
        $select.selected = undefined;
        // reset search query
        $select.search = undefined;
        // focus and open dropdown
        $select.activate();
    }

    refreshResults($select: any) {
        let search = $select.search,
            list = ng.copy($select.items),
            FLAG = -1;
        // remove last user input
        list = list.filter((item) => {
            return item._id !== FLAG;
        });
        if (!search) {
            // use the predefined list
            $select.items = list;
        } else {
            // manually add user input and set selection
            let userInputItem = {
                _id: FLAG,
                full_name: search
            };
            $select.items = [userInputItem].concat(list);
            $select.selected = userInputItem;
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/services/ui-select.service.ts